import styled from 'styled-components';

import React from 'react';

const Div = styled.div`
    margin-left: 16px;
    margin-top: 8px;
    color: ${(props) => props.theme.tertiaryFontColor};
    font-weight: 400;
    font-size: 12px;
`;
const Subtext = ({ children }) => {
    return <Div>{children}</Div>;
};

export default Subtext;
